import { api } from '@api/api2';
import type { GetResidentParentListPayload } from './types';

export const getResidentParentList = (payload: GetResidentParentListPayload) =>
  api.v4('get', 'residents-new/support/available-parent-list', payload);
